export default "__VITE_ASSET__DnNYoll___"